import CreateNewsContainer from "../containers/CreateNewsContainer";

const CreateNewsPage = () => {
  return (
    <CreateNewsContainer />
  );
};

export default CreateNewsPage;
